/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
export const CONNECTED_APPS_QUERY_KEYS = {
  list: ['connected-apps', 'list'] as const,
};
